import { FaTimes, FaWindowMaximize, FaWindowMinimize } from "react-icons/fa";
import React, { useState } from "react";

const Window = ({
  title,
  children,
  onClose,
  onMinimize,
  onMaximize,
  minimized,
  maximized,
  isMobile,
}) => {
  const [position, setPosition] = useState({ x: 100, y: 100 });
  const [isDragging, setIsDragging] = useState(false);
  const [dragOffset, setDragOffset] = useState({ x: 0, y: 0 });

  const handleMouseDown = (e) => {
    setIsDragging(true);
    setDragOffset({
      x: e.clientX - position.x,
      y: e.clientY - position.y,
    });
  };

  const handleMouseMove = (e) => {
    if (isDragging) {
      setPosition({
        x: e.clientX - dragOffset.x,
        y: e.clientY - dragOffset.y,
      });
    }
  };

  const handleMouseUp = () => {
    setIsDragging(false);
  };

  React.useEffect(() => {
    if (isDragging) {
      window.addEventListener("mousemove", handleMouseMove);
      window.addEventListener("mouseup", handleMouseUp);
    }

    return () => {
      window.removeEventListener("mousemove", handleMouseMove);
      window.removeEventListener("mouseup", handleMouseUp);
    };
  }, [isDragging]);

  return (
    <div
      className={`${
        isMobile
          ? "fixed inset-0 w-full h-full z-40"
          : "absolute bg-white shadow-xl rounded-md overflow-hidden border border-gray-300 transition-all"
      } ${minimized ? "hidden" : "block"}`}
      style={{
        width: !isMobile ? (maximized ? "100%" : "min(90%, 500px)") : "100%",
        height: !isMobile ? (maximized ? "100%" : "min(90%, 400px)") : "100%",
        left: !isMobile ? (maximized ? "0" : `${position.x}px`) : "0",
        top: !isMobile ? (maximized ? "0" : `${position.y}px`) : "0",
        zIndex: 50,
      }}
    >
      <div
        className={`bg-blue-600 text-white p-2 flex justify-between items-center ${
          !isMobile ? "cursor-move" : ""
        }`}
        onMouseDown={!isMobile ? handleMouseDown : undefined}
      >
        <div className="font-medium truncate">{title}</div>
        <div className="flex space-x-2">
          {!isMobile ? (
            <>
              <button
                className="hover:bg-blue-500 p-1 rounded"
                onClick={onMinimize}
              >
                <FaWindowMinimize size={12} />
              </button>
              <button
                className="hover:bg-blue-500 p-1 rounded"
                onClick={onMaximize}
              >
                <FaWindowMaximize size={12} />
              </button>
              <button className="bg-red-500 p-1 rounded" onClick={onClose}>
                <FaTimes size={12} />
              </button>
            </>
          ) : (
            <button
              className="bg-red-600 w-8 h-8 rounded-full flex items-center justify-center hover:bg-red-700 transition-colors"
              onClick={onClose}
            >
              <FaTimes size={16} />
            </button>
          )}
        </div>
      </div>

      <div
        className={`${
          isMobile ? "bg-white pb-20" : "p-2 md:p-4"
        } h-[calc(100%-40px)] overflow-auto`}
      >
        {isMobile ? (
          <div className="bg-white p-3 min-h-full">{children}</div>
        ) : (
          children
        )}
      </div>
    </div>
  );
};

export default Window;
